import NimbleMobileLogo from '../../../assets/nimble-navbar-v2-logo-mobile.png';
import NimbleLogoSVG from '../../../assets/nimble-navbar-v2-logo.svg';
import { NimbleLogoContainer, NimbleMobileLogoContainer } from './styles';
import { NimbleLogoProps } from '../types';

export const NimbleLogo: React.FC<NimbleLogoProps> = ({ isMobile }) => {
  const logoToShow = isMobile ? NimbleMobileLogo : NimbleLogoSVG;
  const LogoContainer = isMobile ? NimbleMobileLogoContainer : NimbleLogoContainer;

  return <LogoContainer src={logoToShow} sx={{ mr: 1 }} alt="nimbleLogo" />;
};
